import { render, staticRenderFns } from "./CustomerStatusChip.vue?vue&type=template&id=c1a46a24&scoped=true"
import script from "./CustomerStatusChip.vue?vue&type=script&lang=js"
export * from "./CustomerStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a46a24",
  null
  
)

export default component.exports